// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Df","flipped":"Ef","mainContentContainer":"Ff","cta":"Gf","mainContentCtaDefault":"Hf","disabled":"If","mainContentCtaWhite":"Jf"};